export default (store) => {
  store.subscribe((mutation) => {
    if (mutation) {
      switch (mutation.type) {
        case 'shoppingCart/SET_SHOPPING_CART_INIT':
        case 'auth/SET_ASSIGNED_ROUTES':
        case 'auth/SET_CURRENT_USER':
        case 'auth/SET_CURRENT_USER_PROFILE':
          break;
        default:
          if (window.appInsights) {
            window.appInsights.trackEvent({ name: mutation.type });
          }
          break;
      }
    }
  });
};



// WEBPACK FOOTER //
// ./src/store/middlewares/insights.js